export default () => (scope, element, attrs) => element.bind("keydown keypress", function (event) {
    if (event.which === 13) {
        console.log('ngEnter.$apply', attrs);
        scope.$apply(function () {
            console.warn(attrs.ngEnter, { 'event': event, '$value': element.val() });
            scope.$eval(attrs.ngEnter, { 'event': event, '$value': element.val() });
        });

        event.preventDefault();
    }
});